import { useState, useEffect, useCallback } from 'react';
import { useSidebar } from '../contexts/SidebarContext';

// Largeur appliquée en margin-left au contenu principal.
// IMPORTANT : sur mobile (<768px) la sidebar est un drawer en position fixed
// (translateX hors écran). Le contenu ne doit donc recevoir AUCUN margin-left,
// sinon il est décalé horizontalement dans le vide.
export const useSidebarSync = () => {
  const { isExpanded } = useSidebar();
  const [sidebarWidth, setSidebarWidth] = useState(
    typeof window !== 'undefined' && window.innerWidth < 768 ? '0px' : '288px'
  );

  // useCallback pour éviter les recréations de fonction
  const updateWidth = useCallback(() => {
    const isMobile = window.innerWidth < 768;
    const newWidth = isMobile ? '0px' : isExpanded ? '288px' : '80px';
    setSidebarWidth(prevWidth => {
      // Éviter les mises à jour inutiles
      if (prevWidth !== newWidth) {
        return newWidth;
      }
      return prevWidth;
    });
  }, [isExpanded]);

  // Recalcule au montage, au changement d'état et au redimensionnement
  // (passage desktop <-> mobile sans recharger la page).
  useEffect(() => {
    updateWidth();
    window.addEventListener('resize', updateWidth);
    return () => window.removeEventListener('resize', updateWidth);
  }, [updateWidth]);

  return sidebarWidth;
};

export default useSidebarSync;
